import React, { useEffect, useState } from 'react'
import Header from '../../../components/generals/header'
import stylesIndex from './../../../css/Index.module.css'
import store from '../../../reducer/store'
import DataTableDemo from '../../../components/generals/datatables/datatable'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import ToggleButton from 'react-bootstrap/ToggleButton'
import styles from '../../../css/reports/Reports.module.css'
import { getData } from '../../../actions/servicesHttp'
import { formatDate } from '../../../components/generals/charts/utils/DatesFormats'
import { NavLink, useNavigate } from 'react-router-dom'
import { Button } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import Loading from '../../../components/generals/loading'

export default function DevicesLocationReport () {
  const { t, ready } = useTranslation('devicesLocationReport')
  const { user } = store.getState()
  const role = user.roles
  const navigate = useNavigate()
  const [dateFilter, setDateFilter] = useState(0)
  const [urlDevicesLocationReport] = useState('reports/devices-location-report')
  const [devicesLocationReport, setDevicesLocationReport] = useState(null)

  const columns = [
    { field: 'id_user', header: t('headers.one') },
    { field: 'serial_number', header: t('headers.two') },
    { field: 'type', header: t('headers.three') },
    { field: 'date', header: t('headers.four') },
    { field: 'place', header: t('headers.five') },
    { field: 'lat', header: t('headers.six') },
    { field: 'lon', header: t('headers.seven') },
    { field: 'precision', header: t('headers.eight') }
  ]

  // Filtro de fecha
  const dates = [
    { name: t('button1'), value: 31 },
    { name: t('button2'), value: 0 }
  ]

  const getDevicesLocationReport = async (dateFilter) => {
    const response = await getData(urlDevicesLocationReport, JSON.stringify({ dateFilter }), navigate)

    if (response?.status === 200) {
      const devices = response?.data?.map((device) => {
        if (device.locations[0]) {
          const location = device.locations[0]
          const deviceType = location.type.toUpperCase()

          device.date = device.date === null ? t('noDisponible') : formatDate(location.date)
          device.place = location.place ? location.place.replaceAll(',', ' ') : t('noDisponible')
          device.lat = location.lat
          device.lon = location.lon
          device.precision = deviceType === 'SO' ? t('label1') : t('label2')
          device.type = device.type.toLowerCase()

          delete device.locations
        }
        return device
      })
      setDevicesLocationReport(devices)
    } else {
      setDevicesLocationReport([])
    }
  }
  useEffect(() => {
    if (ready) {
      getDevicesLocationReport(dateFilter)
    }
  }, [dateFilter, ready])

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
        <Header title={t('title')} />
        <div>
          <NavLink to="/mdm/reports">
              <Button variant="dark" className={styles.return_btn}>
                <i className="pi pi-arrow-circle-left" style={{ marginRight: '0.5rem' }}></i>
                {t('button3')}
              </Button>
          </NavLink>
        </div>
          <div className={styles.btnsContainer}>
            <ButtonGroup className={styles.dateFilterContainer}>
              {dates.map((date, index) => (
                <ToggleButton
                  key={index}
                  id={`date-${index}`}
                  type="radio"
                  variant="secondary"
                  name="date"
                  value={date.value}
                  checked={date.value === dateFilter}
                  className={styles.btnDateReport}
                  onChange={(e) => {
                    setDateFilter(parseInt(e.target.value))
                    setDevicesLocationReport(null)
                  }}
                >
                  {date.name}
                </ToggleButton>
              ))}
            </ButtonGroup>
          </div>
        <div>
          {devicesLocationReport === null && <Loading color="primary" />}
          {devicesLocationReport !== null && <DataTableDemo
            data={devicesLocationReport}
            reload={() => getDevicesLocationReport(dateFilter)}
            editUsers={false}
            rowStates={false}
            rowSelecteds={false}
            exportsPdf={role?.reportsPage.exportPdfInReport}
            exportsCsv={role?.reportsPage.exportCsvInReport}
            actionDelete={false}
            actionDashboard={false}
            table="devicesLocationReport"
            searchs={['id_user', 'serial_number']}
            columns={columns}
            namePdf={t('namePdf')}
          />}
        </div>
      </div>
    </div>
  )
}
